import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	components: {
		app: {

		},
		disclaimers: {
			pageDisclaimers: {
				enabled: true,
			},
			queries: {
				disclaimers: [
					{
						text: {
							queryOptionsType: 'none',
							value: 'This is a dynamic disclaimer... but not',
						},
					},
				],
			},
		},
	},
};
